// extracted by mini-css-extract-plugin
export default {"root":"entrance-prices-table_root__hJBTA"};